module.exports = __webpack_public_path__ + "static/media/grass_fed_beef_mobile.f3af2dde.mp4";